import { render, staticRenderFns } from "./delivery-list.vue?vue&type=template&id=819c3fde&scoped=true&"
import script from "./delivery-list.vue?vue&type=script&lang=js&"
export * from "./delivery-list.vue?vue&type=script&lang=js&"
import style0 from "./delivery-list.vue?vue&type=style&index=0&id=819c3fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819c3fde",
  null
  
)

export default component.exports